module.exports = __webpack_public_path__ + "img/index_news.98679316.svg";